export default __webpack_public_path__ + "static/media/clientCase5.21929c6c.png";